import { render, staticRenderFns } from "./centerManualAbsentList.vue?vue&type=template&id=2bb802e0&"
import script from "./centerManualAbsentList.vue?vue&type=script&lang=js&"
export * from "./centerManualAbsentList.vue?vue&type=script&lang=js&"
import style0 from "./centerManualAbsentList.vue?vue&type=style&index=0&id=2bb802e0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports